<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core"
import { computed } from "vue"

import { Input } from "@/components/ui/input"
import { InputGroupInput } from "@/components/ui/input-group"

const value = defineModel("modelValue", { default: "" })
const props = defineProps<{
  group?: boolean
  debounce?: number
}>()

const debouncedInput = useDebounceFn(
  (val: string) => (value.value = val),
  props.debounce ?? 0,
)

const inputValue = computed({
  get: () => value.value,
  set: (newValue: string) => {
    debouncedInput(newValue)
  },
})
</script>

<template>
  <InputGroupInput v-if="group" v-model="inputValue" />
  <Input v-else v-model="inputValue" />
</template>
